import React, {Component} from "react";
import Form from "../../components/forms/ConfirmForm";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {cancelRemoveGiftMessage, successRemoveGiftMessage} from "../../actions/CheckoutApiActions";

class RemoveGiftMessageFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.unmarkAsGift({orderId: this.props.orderId})
      .then((response) => {
        if (response.data.unmarkAsGift.errors.length <= 0) {
          this.setState({errors: []});     
          this.props.successRemoveGiftMessage();   
        } else {
          let errors = createValidationErrors(response.data.unmarkAsGift.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRemoveGiftMessage();
  }

  render() {
    return (
      <Form
        message="Are you sure you want to remove the gift message?"
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const UNMARK_AS_GIFT = gql`
  mutation unmarkAsGift($data: UnmarkAsGiftInput!) {
    unmarkAsGift(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(UNMARK_AS_GIFT, {
    props: ({ mutate }) => ({
      unmarkAsGift: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelRemoveGiftMessage, successRemoveGiftMessage})(withQueries(RemoveGiftMessageFormContainer));